import {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {useNavigate} from "react-router-dom";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import HostNameAndTldAndCurrencyCodeAndApiKeyList from "../IntegrationFormInput/HostNameAndTldAndCurrencyCodeAndApiKeyList.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";

export default function GlamiIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let {resetCurrentUserProjects} = useContext(GlobalContext);
    let navigate = useNavigate();

    let authorityConfiguration = useAuthorityConfiguration();

    let [glamiSettings, setGlamiSettings] = useState({
        hostNameAndTldAndApiCurrencyCodeApiKeyData: [],
    });

    let createGlamiIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .glamiIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                glamiIntegrationInput: glamiSettings,
            })
            .then(glamiIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + glamiIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then(toast.error));
    };

    return (
        <div className={'flex flex-col gap-2'}>
            <HostNameAndTldAndCurrencyCodeAndApiKeyList
                project={project}
                projectIntegration={projectIntegration}
                value={glamiSettings.hostNameAndTldAndApiCurrencyCodeApiKeyData}
                apiKeySameForAll={false}
                onChange={(hostNameAndTldAndApiCurrencyCodeApiKeyData) => {
                    setGlamiSettings((glamiSettings) => {
                        return {
                            ...glamiSettings,
                            hostNameAndTldAndApiCurrencyCodeApiKeyData: hostNameAndTldAndApiCurrencyCodeApiKeyData,
                        };
                    });
                }}
            />

            <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>

            <div className={'flex justify-end'}>
                <Button
                    className={'button-primary'}
                    onClick={() => createGlamiIntegration()}
                    title={t('project.integration-create')}
                >
                    {projectIntegration
                        ? t('project.integration-update')
                        : t('project.integration-create')}
                </Button>
            </div>
        </div>
    );
}
